import React, { memo, useContext } from 'react';
import ReactMarkdown from 'react-markdown';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import PageContext from '../../../../../contexts/PageContext';
import ResumeTimelineItem from '../../containers/ResumeTimelineItem';
import { formatDateMMMYYYY, safetyCheck } from '../../../../../utils';
import fontSizeOptions from '../../../../../constants/fontSizeOptions';

const useStyles = makeStyles({
  root: {
    fontSize: (props) => props,
  },
});

const CertificationItem = ({ item, fontSize }) => {
  const classes = useStyles({
    fontSize: fontSizeOptions['text-base'] + fontSize,
  });

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="flex flex-col text-left mr-2">
          <h3
            className="font-semibold"
            style={{ fontSize: fontSizeOptions['text-h3'] + fontSize }}
          >
            {item.title}
          </h3>
          <h4 style={{ fontSize: fontSizeOptions['text-h4'] + fontSize }}>
            {item.issuer}
          </h4>
        </div>
      </div>
      {item.summary && (
        <ReactMarkdown
          className={`markdown mt-2 ${classes.root}`}
          source={item.summary}
        />
      )}
    </div>
  );
};

const CertificationDate = ({ item, language, fontSize }) => {
  const { t } = useTranslation();

  return (
    <div>
      {item.date && (
        <h6
          className="font-medium text-right"
          style={{ fontSize: fontSizeOptions['text-base'] + fontSize }}
        >
          {formatDateMMMYYYY({ date: item.date, language }, t)}
        </h6>
      )}
    </div>
  );
};

const CertificationsD = () => {
  const { data, heading: Heading } = useContext(PageContext);
  const colour = data.metadata.colors.primary;
  const certificationDate = (x) => (
    <CertificationDate
      key={x.id}
      item={x}
      language={data.metadata.language}
      fontSize={data.metadata.margins.fontSize}
    />
  );
  return safetyCheck(data.certifications) ? (
    <>
      <Heading
        fontSize={data.metadata.margins.fontSize}
        iconId="certifications"
      >
        {data.certifications.heading}
      </Heading>
      {data.certifications.items.map((x) => (
        <ResumeTimelineItem
          key={x.id}
          leftContent={certificationDate(x)}
          colour={colour}
          margin={data.metadata.margins.lrMargins}
        >
          {' '}
          <CertificationItem
            key={x.id}
            item={x}
            fontSize={data.metadata.margins.fontSize}
          />
        </ResumeTimelineItem>
      ))}
    </>
  ) : null;
};

export default memo(CertificationsD);
